import numbro from 'numbro'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailsRowItem } from './DetailsRowItem'
import { PricingPackageType } from './PayInvoiceModal'

export const FeeOrDiscount: React.FC<{
  paymentMethod: any
  pricingPackage: PricingPackageType | null
}> = ({ paymentMethod, pricingPackage }) => {
  const { t } = useTranslation('global')
  const fee = pricingPackage ? pricingPackage.fee : 0
  const showDiscount = useMemo(
    () =>
      paymentMethod.paymentMethodType === 'bank' &&
      pricingPackage?.discount &&
      pricingPackage?.discount > 0,
    [paymentMethod, pricingPackage],
  )
  return showDiscount ? (
    <DetailsRowItem
      leftText={`${t('payInvoice.discount')}:`}
      rightText={`-$${numbro(pricingPackage?.discount).format({
        thousandSeparated: true,
        mantissa: 2,
      })}`}
    />
  ) : (
    <DetailsRowItem
      leftText={`${t('payInvoice.servicing_fee')}:`}
      rightText={fee}
      money
    />
  )
}
